import React from "react";
import { Container } from "react-bootstrap";
import { FaLinkedinIn } from "react-icons/fa";
import { IconMail } from "@tabler/icons-react";
import {
  contactEmail,
  contactGmailComposeUrl,
  linkedinUrl,
} from "../data/siteMeta";

function Footer() {
  return (
    <Container fluid className="footer">
      <Container className="footer-inner section-shell">
        <div className="footer-copy">
          <h3>Om Jaiswal</h3>
          <p>
            Full stack developer building websites, web apps, and APIs
            end-to-end — with clear UX and solid architecture at every layer.
          </p>
        </div>

        <div className="footer-contact">
          <a className="footer-mail" href={contactGmailComposeUrl}>
            {contactEmail}
          </a>
          <span>Pune, India</span>
        </div>

        <ul className="footer-icons">
            <li className="social-icons">
              <a
                href={linkedinUrl}
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Open Om Jaiswal LinkedIn profile in a new tab"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href={contactGmailComposeUrl}
                className="footer-social-link"
                aria-label="Open Gmail to email Om Jaiswal"
              >
                <IconMail size={18}/>
              </a>
            </li>
          </ul>
      </Container>
    </Container>
  );
}

export default Footer;
